<mat-divider></mat-divider>

<p class="mat-subheading-2">Gestionnaires de cette page</p>

<div>

  <div fxLayout="column" fxFlex="100" fxLayoutAlign="start">
    <mat-expansion-panel expanded="true" class="role">
      <mat-expansion-panel-header>
        <mat-panel-title>
          Les gestionnaires qui peuvent éditer cette page - ils doivent avoir été au préalable renseignés en tant que gestionnaires Bdc
        </mat-panel-title>
      </mat-expansion-panel-header>

      <mat-card>

        <mat-card-content fxLayout="column">
          <mat-slide-toggle *ngIf="page.numchild > 0"
                            [checked]="withChildren"
                            (change)="onChecked($event)"
                            matTooltip="{{withChildren?'pour toutes les pages de la rubique':'uniquement cette page'}}">
            Appliquer ou non à toutes les pages de cette page / rubrique, elle comprise
          </mat-slide-toggle>

          <mat-form-field fxLayout="column">
            <mat-chip-listbox #chipList>
              <mat-chip
                *ngFor="let gest of pageUsers"
                [selectable]="true"
                [removable]="true"
                (removed)="deleteConfirmGestionnaireDialog(gest)">
                {{gest.user_obj?.first_name}} {{gest.user_obj?.last_name}}
                <mat-icon matChipRemove >cancel</mat-icon>
              </mat-chip>
              <input matInput
                     type="text"
                     name="searchInput"
                     placeholder="Rechercher et ajouter un gestionnaire"
                     #inputSearch
                     [matChipInputFor]="chipList"
                     [formControl]="GestionnaireControl"
                     [matAutocomplete]="auto"
                     [(ngModel)]="searchTerm">

            </mat-chip-listbox>

          </mat-form-field>

          <mat-autocomplete #auto="matAutocomplete" fxLayout="column">
            <mat-option *ngFor="let gest of gestionnaireSearch | async"
                        (onSelectionChange)="addSelectedGestionnaire(gest)">
              {{ gest?.individu?.last_name }} {{gest?.individu?.first_name}}
            </mat-option>
          </mat-autocomplete>

        </mat-card-content>

      </mat-card>

    </mat-expansion-panel>
  </div>

</div>
